import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function FooterComponent() {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <footer className="bg-white py-10 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center md:flex-row md:justify-center md:items-center mb-8">
          <h2 className="sr-only">Download Our App</h2>
          <div className="flex flex-col justify-between w-full sm:flex-row sm:space-x-4">
            <div>
              <a href="#" className="inline-block mb-4 sm:mb-0">
                <img
                  src="Images/logo.png"
                  alt="Mzansi Save Logo"
                  className="h-60 object-contain mb-[-60px] mt-[-60px]"
                />
              </a>
            </div>
            {/* <div>
              <a href="#" className="inline-block mr-2">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Get it on Google Play"
                  className="h-12 object-contain"
                />
              </a>
              <a href="#" className="inline-block">
                <img
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                  alt="Download on the App Store"
                  className="h-12 object-contain"
                />
              </a>
            </div> */}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8">
          <div>
            <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3">
              Stokvels
            </h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/how-it-works" className="hover:text-cyan-600">How It Works</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3">
              Services
            </h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/graduate-agents" className="hover:text-cyan-600">Graduate Agents</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3">
              Company 
            </h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/about-us" className="hover:text-cyan-600">About Mzansi Save</Link></li>
              <li><Link to="/contact-us" className="hover:text-cyan-600">Contact Us</Link></li>
              <li><Link to="/resources" className="hover:text-cyan-600">Resources</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3">
              Support
            </h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/faqs" className="hover:text-cyan-600">FAQs</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3">
              Legal
            </h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/termsofuse" className="hover:text-cyan-600">Terms of Use</Link></li>
              <li><Link to="/privacy" className="hover:text-cyan-600">Privacy Policy</Link></li>
              <li><Link to="/regulation" className="hover:text-cyan-600">Regulation & Compliance</Link></li>
              <li><Link to="/complaints-policy" className="hover:text-cyan-600">Complaints Policy</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="text-black p-3 text-center text-xs">
        <div className="max-w-7xl mx-auto text-left text-gray-700">
          <h5 className="font-bold">Mzansi Save's Role</h5>
          <p>
            Mzansi Save operates as a digital platform facilitating modern stokvel services. 
            Mzansi Save does not 
            hold client funds directly but provides technology and community support services 
            to modernize traditional stokvel practices.
          </p>

          <h5 className="font-bold mt-2">Regulatory Compliance</h5>
          <p>
            Financial services are provided through Sharenet, an Authorised Financial Services 
            Provider (FSP 28430 & 41688) regulated by the Financial Sector Conduct Authority (FSCA). 
          </p>

          <h5 className="font-bold mt-2">Partnership Framework</h5>
          <p>
            Mzansi Save operates through strategic partnerships with established financial institutions. 
            Sharenet ensures regulatory 
            compliance and financial services oversight. This partnership structure ensures member 
            funds are protected under established banking regulations.
          </p>

          <h5 className="font-bold mt-2">Trademark and Legal Notices</h5>
          <p>
            The Mzansi Save name, logo, and related trademarks are protected under trademark law. 
            Unauthorised use is prohibited. This platform respects and honors South Africa's 
            traditional stokvel practices while providing modern digital enhancements.
          </p>

          <h5 className="font-bold mt-2">Community Responsibility</h5>
          <p>
            Stokvel participation involves community trust and shared financial responsibility. 
            Members should carefully consider their commitments and ensure they understand 
            group rules and obligations before joining. Mzansi Save provides tools and education 
            but cannot guarantee individual stokvel performance or member compliance.
          </p>

          <h5 className="font-bold mt-2">Privacy and Data Protection</h5>
          <p>
            For privacy concerns, contact{' '}
            <a href="mailto:info@mzansisave.co.za" className="underline text-cyan-600">
              info@mzansisave.co.za
            </a> or call 021 700 4800. Read our Privacy Policy for details on data handling. 
            Mzansi Save is compliant with the Protection of Personal Information Act (POPIA) 
            and registered with the South African Information Regulator.
          </p>

          <h5 className="font-bold mt-2">Financial Education Commitment</h5>
          <p>
            Through our Graduate Agents programme and community outreach, Mzansi Save is committed 
            to improving financial literacy and supporting unemployed youth. Our educational 
            initiatives aim to strengthen communities through better money management and 
            understanding of both traditional and modern saving practices.
          </p>
        </div>
      </div>
    </footer>
  );
}
